module.exports = __webpack_public_path__ + "static/media/126-users.9027bba2.svg";